<template>
    <div class="input-group">
        <span class="input-group-prepend">
          <div class="input-group-text">
            <i class="fa fa-calendar"></i>
          </div>
      </span>
      <datetime :title="label" ref="plugin" type="date" :class="['form-control', `theme-${theme}`, {'is-invalid' : errors.has('date') }]" input-class="text-center w-100" :format="format" :min-datetime="minDatetime" v-model="internalValue"></datetime>
      <div v-if="errors.has('date')" class="invalid-feedback">
          {{ errors.get('date') }}
      </div>
    </div>
</template>

<script>
import { Datetime } from 'vue-datetime'
import { DateTime as DT, Settings } from 'luxon'

export default {
  components: {
    Datetime
  },
  props: {
    value: {
      type: [String],
      default: null
    },
    label: {
      type: [String],
      required: true
    },
    format: {
      type: [String],
      default: 'dd. LLLL yyyy'
    },
    minDatetime: {
      type: [String],
      default: DT.local().toISO()
    },
    locale: {
      type: [String],
      default: 'de-AT'
    },
    theme: {
      type: [String],
      default: 'blue',
      validator: value => ['blue'].indexOf(value) !== -1
    },
    errors: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  created () {
    Settings.defaultLocale = this.locale
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (value) {
        this.lazyValue = value
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value: function (value) {
      if (value !== this.lazyValue) {
        this.lazyValue = value
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~vue-datetime/dist/vue-datetime';

  .theme-blue .vdatetime-popup__header,
  .theme-blue .vdatetime-calendar__month__day--selected > span > span,
  .theme-blue .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #3B5998;
  }

  .form-control input {
      border: none;
  }

  .theme-blue .vdatetime-year-picker__item--selected,
  .theme-blue .vdatetime-time-picker__item--selected,
  .theme-blue .vdatetime-popup__actions__button {
    color: #3B5998;
  }
</style>
